export default __webpack_public_path__ + "static/media/accepted.f567782c.svg";